/** Stable error codes shared by API and clients (UI maps them to French messages). */
export const ERROR_CODES = {
  VALIDATION_FAILED: 'Données invalides',
  UNAUTHENTICATED: 'Session expirée, veuillez vous reconnecter',
  INVALID_CREDENTIALS: 'Identifiants incorrects',
  ACCOUNT_LOCKED: 'Compte temporairement verrouillé',
  ACCOUNT_DISABLED: 'Compte désactivé',
  FORBIDDEN: 'Action non autorisée',
  NOT_FOUND: 'Élément introuvable',
  CONFLICT: 'Conflit de modification',
  INVALID_TRANSITION: 'Changement de statut impossible',
  REASON_REQUIRED: 'Un motif est requis',
  COMMENT_REQUIRED: 'Un commentaire est requis',
  TENANT_INACTIVE: 'Entreprise inactive',
  QUOTA_EXCEEDED: 'Limite de l’abonnement atteinte',
  RATE_LIMITED: 'Trop de tentatives, réessayez plus tard',
  INTERNAL: 'Erreur interne',
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;

export interface ApiErrorBody {
  error: { code: ErrorCode; message: string; details?: unknown };
  requestId?: string;
}
